import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import redirect from 'actions/redirect';

class Login extends Component {
  componentWillMount() {
    this.props.redirect('/', true);
  }

  render() {
    return null;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    redirect: bindActionCreators(redirect, dispatch)
  }
}

export default connect(() => { return {} }, mapDispatchToProps)(Login);
